import { Card } from 'antd';
import styled from 'styled-components';

const ReportCard = styled(Card)`
  .ant-card-head {
    font-weight: normal;
    color: rgba(0, 0, 0, 0.45);
    text-transform: uppercase;
    border-bottom: none;
  }
  .ant-card-body {
    height: 225px;
  }
  .ant-card-extra {
    padding: 10px 0;
  }
  .ant-card-extra > button {
    padding: 0;
  }
`;

export default ReportCard;
